<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container">
      <!-- 富文本 -->
      <div class="b-container">
        <div class="b-center-main">
          <div class="b-richtext">
            <p v-html="richText"></p>
          </div>
          <div id="right" style="float:right; width:47%; height:100%;">
            <v-slider2></v-slider2>
          </div>
          <div class="b-richtext">
            <p v-html="richText2"></p>
          </div>
          <div id="right2" style="float:right; width:47%; height:100%; margin-top: 5px">
            <v-slider3></v-slider3>
          </div>
          <div class="b-richtext">
            <p v-html="richText3"></p>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
    <!--
    <v-footer></v-footer>
    <v-copy></v-copy>
    -->
  </div>
</template>
<script>
  /* eslint-disable */
  import Header from "@/components/header/en/";
  import Nav from "@/components/nav/en/";
  import Breadcrumb from "@/components/breadcrumb/en/"
  import Contact from "@/components/contact/en/";
  import Slider2 from '@/components/slider2/'// 引入slider组件
  import Slider3 from '@/components/slider3/'// 引入slider组件
  import $ from "jquery";
  export default {
    data () {
      return {
        richText: '',
        richText2: '',
        richText3: '',
      };
    },
    created () {
      if(this.$route.query.id == 'zhyxjd') {
        this.richText = '<p style="text-align: left; "><span style="font-size: 22px; border-bottom: solid 3px #033d80;">Base Coordination</span></p>'
          + '<p style="text-align: center"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/jdxt1_en.png" style="width: 810px; margin-right: 16px;margin-bottom: 16px;" width="800px"  border="0" vspace="0" alt=""></p>'
          // + '<p style="text-align: center"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/jsxtfb1.png" style="width: 820px; margin-right: 16px;margin-bottom: 16px;" width="800px"  border="0" vspace="0" alt=""></p>'

          + '<p>&nbsp;</p>'
          + '<p style="text-align: left; margin-bottom: 40px"><span style="font-size: 22px; border-bottom: solid 3px #033d80;">Minhang base</span></p>'

          + '<div id="left" style="float:left ; width:48%; margin-left: 0px;  height:310px;">'
          // + '<img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/mhjd1.png" style="margin-right: 16px;margin-bottom: 16px;margin-top: 6px;" border="0" vspace="0" alt="">'
          + '<p style="margin-bottom : 20px; text-align: justify"><span style="font-size: 16px; ">Minhang base, located at Minhang Campus of SJTU, covers an area of ​​about 60,000 ㎡ and can accommodate over 1,000 researchers for scientific research activities, that includes 900 researchers (including graduate students) and 100 Technicians.</span></p>'
          + '<p style="margin-bottom : 20px; text-align: justify"><span style="font-size: 16px; ">Minhang Base: 800 Dongchuan Road, Minhang District, Shanghai, P.R. China</span></p>'

          // + '<p style="margin-bottom : 20px; margin-top: 0px;"><span style="font-size: 20px; color: white;font-weight: bold"></span></p>'
          // + '<p style="margin-bottom : 20px; "><span style="font-size: 16px; ">闵行基地使用面积为 6 万平方米，同时容纳 1000 人进行科研活动， 包括流动科研人员（含研究生）900 人，平台支撑人员 100 人。</span></p>'
          // + '<p style="margin-bottom : 20px; "><span style="font-size: 16px; ">综合交大本部学科优势和研究基 础，大设施闵行技术平台规划了 5 个功能子平台(临床资源深度分析 和挖掘平台、生物标记物与新药研 发平台、影像平台、诊断试剂研发 平台、仪器研发平台)和 1 个大设 施运行管理系统，可支撑 100 个课 题组同时开展研究工作。</span></p>'
          // + '<ul>' +
          // '<li style="margin-top: 0px; margin-left: 0px; margin-right: 26px; margin-top: 16px;font-size: 16px;">▶ 地理位置：上海市闵行区上海交通大学校内</li>' +
          // '<li style="margin-top: 10px; margin-left: 0px;font-size: 16px;">▶ 建筑面积:6 万平方米</li>' +
          // '<li style="margin-top: 10px; margin-left: 0px;font-size: 16px;">▶ 楼层:6 层(地上 5 层，地下 1 层 )</li>' +
          // '<li style="margin-top: 10px; margin-left: 0px;font-size: 16px;">▶ 建筑高度:23.8 米</li>' +
          // '</ul>'
          + '</div>';


          // + '<div id="right" style="float:right ; width:45%; height:100%;">'
          // +'<v-slider2></v-slider2>'
          //  + '<img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/四区.png" style="width: 460px; margin-right: 60px;margin-bottom: 6px;margin-top: 6px;" width="800px"  border="0" vspace="0" alt="">'
          // + '<p style="margin-bottom : 20px;margin-left: 10px; "><span style="font-size: 16px; "><font color="#033d80">基本定位:</font><br/>转化医学技术研发支撑平台<br/>技术服务能力平台<br/>用户共享实验室<br/><font color="#033d80">开放对象:</font><br/>创新药物、医用材料、生物医学制造、生物医学信息、影像学、诊疗新技术等方面的科学研究与技术开发的优秀团队和科学家。</p>'
          // + '</div>'

        this.richText2 =
          '<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>'
          // + '<p style="margin-top : 60px; margin-bottom : 20px; text-align: justify"><span style="font-size: 16px; ">Minhang base, located at Minhang Campus of SJTU, covers an area of ​​about 60,000 ㎡ and can accommodate over 1,000 researchers for scientific research activities, that includes 900 researchers (including graduate students) and 100 Technicians.</span></p>'
          // + '<p style="margin-bottom : 20px; text-align: justify"><span style="font-size: 16px; ">Minhang Base: 800 Dongchuan Road, Minhang District, Shanghai, P.R. China</span></p>'
          // + '<p>&nbsp;</p>'

          + '<p style="text-align: left; margin-bottom: 40px"><span style="font-size: 22px;border-bottom: solid 3px #033d80;">Ruijin Base</span></p>'
          + '<div id="left" style="float:left ; width:48%; margin-left: 0px;  height:360px;">'
          + '<p style="margin-bottom : 20px; text-align: justify"><span style="font-size: 16px; ">Ruijin Base, located at the Affiliated Ruijin Hospital of SJTU, covers an area of about 54,000 ㎡, and it can accommodate about 500 researchers to carry out scientific research and clinical trials at the same time.</span></p>'
          + '<p style="margin-bottom : 20px; text-align: justify"><span style="font-size: 16px; ">Ruijin Base:  197 Ruijin Second Road, Huangpu District, Shanghai, P.R. China</span></p>'

          // + '<img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/rjjd1.png" style="margin-right:16px; margin-bottom: 16px; margin-top: 6px;" width="800px"  border="0" vspace="0" alt="">'
          // + '<p style="margin-bottom : 20px; margin-top: 20px;"><span style="font-size: 20px; color: white;font-weight: bold"></span></p>'
          // + '<p style="margin-bottom : 20px; margin-right: 16px; "><span style="font-size: 16px;">瑞金基地大楼建成后使用面积为 5.4 万平方米，同时容纳约 500 人 进行科研及临床试验工作。</span></p>'
          // + '<p style="margin-bottom : 20px; margin-right: 16px; "><span style="font-size: 16px;">综合瑞金医院学科优势和研究基 础，大设施瑞金平台规划了 5 个功 能子平台(标准化临床生物样本库、 临床资源深度分析和挖掘平台、生 物标记物与新药研发平台、分子病 理与影像技术研究平台、转化医学 研究型病房)，其中，300 张研究 型床位全部开放可以满足同时进行 20~30 项临床研究。</span></p>'
          // + '</div>'
          //
          // + '<div id="right" style="float:left ; width:45%; height:100%;">'
          // + '<img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/rjjd0.png" style="margin-left: 26px; margin-bottom: 16px;" width="800px"  border="0" vspace="0" alt="">'
          // + '<ul>' +
          // '<li style="margin-top: 0px; margin-left: 36px; margin-right: 26px; margin-top: 26px;font-size: 16px;">▶ 地理位置：上海市黄浦区瑞金医院内</li>' +
          // '<li style="margin-top: 5px; margin-left: 36px;font-size: 16px;">▶ 建筑面积: 5.4 万平方米</li>' +
          // '<li style="margin-top: 5px; margin-left: 36px;font-size: 16px;">▶ 楼层: 16 层(地上 13 层，地下 3 层)</li>' +
          // '<li style="margin-top: 5px; margin-left: 36px;font-size: 16px;">▶ 建筑高度: 56米</li>' +
          // '</ul>'
          + '</div>';
        this.richText3 ='<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>'
          // + '<p style="margin-top : 30px;margin-bottom : 20px; text-align: justify"><span style="font-size: 16px; ">Ruijin Base, located at the Affiliated Ruijin Hospital of SJTU, covers an area of about 54,000 ㎡, and it can accommodate about 500 researchers to carry out scientific research and clinical trials at the same time.</span></p>'
          // + '<p style="margin-bottom : 20px; text-align: justify"><span style="font-size: 16px; ">Ruijin Base:  197 Ruijin Second Road, Huangpu District, Shanghai, P.R. China</span></p>'
          ;
          // + '<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>'
      }

    },
    components: {
      "v-header": Header,
      "v-nav": Nav,
      "v-breadcrumb": Breadcrumb,
      "v-contact": Contact,
      "v-slider2": Slider2,
      "v-slider3": Slider3
    }
  };
</script>
<style lang="scss">
    @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }

  .b-richtext {
    text-align:left;
    b,
    strong {
      font-weight: 700;
    }
    p {
      margin: 0 0 20px;
    }
    line-height: 32px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/about6/en/index.vue